import { render, staticRenderFns } from "./InputRadio.vue?vue&type=template&id=3034e5ed&scoped=true&"
import script from "./InputRadio.vue?vue&type=script&lang=ts&"
export * from "./InputRadio.vue?vue&type=script&lang=ts&"
import style0 from "./InputRadio.vue?vue&type=style&index=0&id=3034e5ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3034e5ed",
  null
  
)

export default component.exports